import type { ReactNode } from 'react'

/**
 * A `loading.tsx` above or inside the frame renders before any page code
 * runs, and a route file there cannot read the UI version (README §4 rule 2).
 * It used to render both fallbacks and let CSS keep one.
 *
 * Since the switch is frozen at 'encuentro' (ALU-625) only the Encuentro
 * fallback renders. The `classic` prop is accepted and ignored so the route
 * files do not change in this step; CL-12 onward removes the classic
 * skeletons together with this wrapper.
 */
export function UiVersionFallback({
  encuentro,
}: {
  /** Ignored: classic no longer renders anywhere. */
  classic?: ReactNode
  encuentro: ReactNode
}) {
  return (
    <div data-ui-fallback="encuentro" className="contents">
      {encuentro}
    </div>
  )
}
